import "../css/header.scss";
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "./CartContext";
import { FiShoppingBag } from "react-icons/fi";

function Header() {
  const { cartItems } = useContext(CartContext);
  const navigate = useNavigate();

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="header-container">
      <div className="left-section">
        <Link to="/shop" className="shop-link" onClick={toTop}>
          Shop
        </Link>{" "}
        <Link to="/about" className="shop-link" onClick={toTop}>
          About
        </Link>{" "}
        <Link to="/contact" className="shop-link" onClick={toTop}>
          Contact Us
        </Link>
      </div>

      <div className="logo-section">
        <Link to="/" onClick={toTop}>
          Liiskerlane
        </Link>
      </div>

      <div className="right-section">
        <div
          className="icon cart-icon-container"
          onClick={() => navigate("/cart")}
        >
          <FiShoppingBag />
          <span className="cart-count">{cartCount}</span>
        </div>
      </div>
    </header>
  );
}

export default Header;
